<template>
  <AppSection
    id="mail-credentials"
    type="section"
    :title="$getConst.pages.mail_credentials.mail_credentials_page_title"
    :is-section-loading="isStarting"
    :button="true"
    :button-icon-svg="$getConst.svgIcons.wifi_sky_blue"
    button-variant="outline"
    button-size="lg"
    :button-icon-svg-tooltip="$t($getConst.pages.connectivity_test.test_smtp_status)"
    @onClick="testSMTP"
  >

    <b-row class="justify-content-center mb-4 pt-4">

      <div class="col-lg-4 mb-3">
        <a
          @click="selectDetails('oauth2')"
          type="button"
          class="card card-box-hover-rise h-100"
          :class="[{'card-active': isOauthActivated && !isStarting}, {'disabled': isLoading || isStarting}]"
        >
          <div v-if="isOauthActivated && !isStarting" class="active-icon-wrapper">
            <div class="active-icon text-center bg-success">
              <i class="fa fa-check text-white"/>
            </div>
          </div>
          <b-collapse id="img-collapse" visible>
            <img
              src="/img/oauth2-smtp.gif"
              class="card-img-top"
              alt="Oauth 2"
            >
          </b-collapse>
          <b-card-body class="border-top">
            <h5 class="card-title text-capitalize font-weight-bold">{{$t($getConst.pages.mail_credentials.mail_credentials_oauth_title)}}</h5>
            <p class="card-text">{{$t($getConst.pages.mail_credentials.mail_credentials_oauth_description)}}.</p>
          </b-card-body>
          <b-card-footer class="text-center">
            <b-link v-if="selectedDetails !== 'oauth2'" class="font-size-lg"><i :class="$getConst.icons.doubleAngleDown" class="font-weight-bold"/></b-link>
            <b-link v-else class="font-size-lg"><i :class="$getConst.icons.doubleAngleUp" class="font-weight-bold"/></b-link>
          </b-card-footer>
        </a>
      </div>

      <div class="col-lg-4 mb-3">
        <a
          @click="selectDetails('basic auth')"
          type="button"
          class="card card-box-hover-rise h-100"
          :class="[{'card-active': !isOauthActivated && !isStarting}, {'disabled': isLoading || isStarting}]"
        >
          <div v-if="!isOauthActivated && !isStarting" class="active-icon-wrapper">
            <div class="active-icon text-center bg-success">
              <i class="fa fa-check text-white"/>
            </div>
          </div>
          <b-collapse id="img-collapse" visible>
            <img
              src="/img/basic-auth-smtp.gif"
              class="card-img-top"
              alt="Basic auth"
            >
          </b-collapse>
          <b-card-body class="border-top">
            <h5 class="card-title text-capitalize font-weight-bold">{{$t($getConst.pages.mail_credentials.mail_credentials_basic_auth_title)}}</h5>
            <p class="card-text">{{$t($getConst.pages.mail_credentials.mail_credentials_basic_auth_description)}}.</p>
          </b-card-body>
          <b-card-footer class="text-center">
            <b-link v-if="selectedDetails !== 'basic auth'" class="font-size-lg"><i :class="$getConst.icons.doubleAngleDown" class="font-weight-bold"/></b-link>
            <b-link v-else class="font-size-lg"><i :class="$getConst.icons.doubleAngleUp" class="font-weight-bold"/></b-link>
          </b-card-footer>
        </a>
      </div>

    </b-row>

    <MailCredentialsForm
      v-if="selectedDetails"
      :scope_id="scope_id"
      :mail-credentials="mailCredentials"
      :auth-type="selectedDetails"
      @onSubmit="setMailCredentials"
      @isLoading="setLoading"
    />

  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
  import {getMailCredentialsByScope, testScopeMailCredentials} from "../../../../api/mailCredentials.api";
  import {snotifyConfig} from "../../../../shared/constants/snotify";
  import MailCredentialsForm from "./MailCredentialsForm";
  export default {
    name: "index",
    components: {MailCredentialsForm, AppFormFeedback, AppConfirmButtons, AppSection},
    props: {
      scope_id: null
    },
    computed: {
      isOauthActivated() {
        return this.mailCredentials && this.mailCredentials.isOauth;
      }
    },
    data() {
      return {
        mailCredentials: null,
        isStarting: false,
        isLoading: false,
        selectedDetails: null
      }
    },
    methods: {
      selectDetails(authType) {
        if (this.selectedDetails === authType) {
          this.selectedDetails = null;
          this.$root.$emit('bv::toggle::collapse', 'img-collapse');
        } else {
          if (this.selectedDetails === null) {
            this.$root.$emit('bv::toggle::collapse', 'img-collapse');
          }
          this.selectedDetails = authType;
        }
      },
      setMailCredentials(credentials) {
        this.mailCredentials = credentials;
      },
      setLoading(isLoading) {
        this.isLoading = isLoading;
      },
      getMailCredentials() {
        this.isStarting = true;
        getMailCredentialsByScope(this.scope_id).then(
          (response) => {
            this.mailCredentials = Object.assign({}, response.data);
            this.isStarting = false;
            if (location.hash.includes("success")) {
              this.selectDetails("oauth2");
              history.replaceState(null, null, " ");
            }
          },
          (error) => {
            this.handleApiError(error);
            this.isStarting = false;
          }
        )
      },

      testSMTP() {
        this.$snotify.async(
          this.$t(this.$getConst.pages.connectivity_test.smtp_request_sending),
          this.$t(this.$getConst.pages.alerts.please_wait),
          () => new Promise((resolve, reject) => {
            testScopeMailCredentials(this.scope_id).then(
              () => {
                resolve({
                  title: this.$t(this.$getConst.pages.alerts.success),
                  body: this.$t(this.$getConst.pages.connectivity_test.smtp_success_message),
                  config: snotifyConfig,
                })
              },
              () => {
                reject({
                  title: this.$t(this.$getConst.pages.alerts.error),
                  body: this.$t(this.$getConst.pages.connectivity_test.smtp_failure_message),
                  config: snotifyConfig
                })
              }
            )
          })
        )
      },

    },
    created() {
      if (location.hash.includes("error")) {
        history.replaceState(null, null, " ");
        this.$snotify.error(
          this.$options.filters.capitalize(this.$t(this.$getConst.pages.alerts.unknown_error)),
          this.$t(this.$getConst.pages.alerts.error_code)+" B23"
        );
      } else if(location.hash.includes("success")) {
        this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
      }
      this.getMailCredentials();
    }
  }
</script>

<style scoped lang="scss">
  .active-icon-wrapper {
    margin: 0;
    position: absolute;
    top: -10px;
    right: -15px
  }
  .active-icon {
    box-shadow: 0 0.313rem 0.8rem rgba(122, 123, 151, .5), 0 0.126rem 0.225rem rgba(122, 123, 151, .3);
    overflow: hidden;
    display: block;
    width: 44px;
    height: 44px;
    line-height: 44px;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    opacity: 1;
    border-radius: 50px;
  }
  .card-active {
    border: 1px solid #28a745;
    background: #28a7452e;
  }
  #success-badge {
    margin-left: -9px;
    margin-top: 0px;
    position: absolute;
  }
</style>
